import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ContractModel, ContractRequest, ContractResourceService, PagedContractModel } from 'hx-services';

@Injectable({providedIn: 'root'})
export class ContractService {
  constructor(
    private contractResourceService: ContractResourceService,
  ) {
  }

  getContractList(params: {
    page?: number, limit?: number, number?: string,
    date?: string, supplierId?: number,
    organizationId?: number, q?: string
  }): Promise<PagedContractModel> {
    return firstValueFrom(this.contractResourceService.getContracts(
      params.date, params.limit, params.number, params.organizationId,
      params.page, params.q, params.supplierId,
    ));
  }

  getContract(contractId: number): Promise<ContractModel> {
    return firstValueFrom(this.contractResourceService.getContractById(contractId));
  }

  createContract(body: ContractRequest): Promise<ContractModel> {
    return firstValueFrom(this.contractResourceService.createContract(body));
  }

  updateContract(contractId: number, body: ContractRequest): Promise<ContractModel> {
    return firstValueFrom(this.contractResourceService.updateContract(contractId, body));
  }

  deleteContract(contractId: number): Promise<any> {
    return firstValueFrom(this.contractResourceService.removeContract(contractId));
  }
}
